// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__mjlAd","title":"AfterFrontImage_title__2ztXU"};